export const prefix = "/gameData/";
export const dataPath = prefix + "data";
export const idsPath = prefix + "ids";
export const settingsPrefix = "/settings/";
